import $ from 'jquery';
window.$ = window.jQuery = $;

require ("@/bootstrap");
